import { render, staticRenderFns } from "./ed-student-info.component.vue?vue&type=template&id=338ee194&scoped=true&"
import script from "./ed-student-info.component.ts?vue&type=script&lang=ts&"
export * from "./ed-student-info.component.ts?vue&type=script&lang=ts&"
import style0 from "./ed-student-info.component.scss?vue&type=style&index=0&id=338ee194&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "338ee194",
  null
  
)

export default component.exports